export const JOB_DESCRIPTION_SUMMARY_KEYS = [
  "role_scope_and_seniority",
  "company_snapshot",
  "day_to_day_reality",
  "requirements_split",
  "team_and_reporting_shape",
  "modality_and_physical_reality",
  "positive_differentiators",
] as const;

export type JobDescriptionSummary = Partial<
  Record<(typeof JOB_DESCRIPTION_SUMMARY_KEYS)[number], string | null>
>;

export const joinSummary = (summary?: JobDescriptionSummary | null): string | null => {
  if (!summary) return null;

  const joined = JOB_DESCRIPTION_SUMMARY_KEYS.map((key) => summary[key]?.trim())
    .filter(Boolean)
    .join(" ");

  return joined || null;
};
